import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export enum CaseServiceReasonType {
    Cancel = "Cancel",
    DelayedDate = "DelayedDate"
}

export class CaseServiceCause extends Resource {
    public override type = 'caseServiceCauses';

    @prop()
    @required()
    public name!: string;

    @prop()
    public caseServiceCauseType: CaseServiceReasonType  = CaseServiceReasonType.DelayedDate;

}